import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import axiosInstance from '../plugins/axios'
import { generateCSS, applyAdditionalSettings } from '../helper/themeHelper'

export const useStyleStore = defineStore('styleStore', () => {
  const styles = ref<Record<string, string>>({})
  const isStylesLoaded = ref(false)

  //const route = useRoute() 
  
  const loadStyles = async () => {
    try {
      /*
      if (route.query.template === 'blank') {
        console.log('Skipping style loading due to template=blank')
        isStylesLoaded.value = true
        return
      }
*/
      const response = await axiosInstance.get('/theme/forFrontend/styles')
      if (response.statusText !== 'OK') throw new Error('Failed to fetch styles')

      const data = await response.data
      styles.value = data
      const additionalSettings = await generateCSS(data)
      await applyAdditionalSettings(additionalSettings)

      isStylesLoaded.value = true
    } catch (error) {
      console.error('Error loading styles:', error)
      isStylesLoaded.value = true
    }
  }

  const getStyles = () => {
    return { ...styles.value }
  }

  const getFavicon = () => {
    console.log('getFavicon', styles?.value)
    return styles?.value?.framworkLogo?.value
  }

  return {
    styles,
    isStylesLoaded,
    loadStyles,
    getStyles,
    getFavicon
  }
})
